var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "history" }, [
    _c("div", { staticClass: "bg" }),
    _c("div", { staticClass: "title-con" }, [
      _c("div", { staticClass: "return-btn-con" }, [
        _c(
          "button",
          {
            staticClass: "return-btn",
            on: {
              click: function ($event) {
                return _vm.$router.go(-1)
              },
            },
          },
          [
            _c("c-svg", {
              attrs: {
                src: "return.svg",
                width: "21",
                height: "21",
                fill: "rgb(217, 222, 229)",
              },
            }),
            _c("div", { staticClass: "text" }),
          ],
          1
        ),
      ]),
      _c("h1", { staticClass: "case-title" }, [_vm._v("对战历史")]),
      _c("div", { staticClass: "block" }),
    ]),
    _c(
      "div",
      { staticClass: "main-content" },
      [
        _c("div", { staticClass: "header" }, [
          _c(
            "div",
            {
              on: {
                click: function ($event) {
                  return _vm.switchTab(0)
                },
              },
            },
            [
              _c("span", { class: { active: _vm.tabId == 0 } }, [
                _vm._v("全部房间"),
              ]),
            ]
          ),
          _c("div", { staticClass: "line" }),
          _c(
            "div",
            {
              on: {
                click: function ($event) {
                  return _vm.switchTab(1)
                },
              },
            },
            [
              _c("span", { class: { active: _vm.tabId == 1 } }, [
                _vm._v("我的房间"),
              ]),
            ]
          ),
        ]),
        _c("div", { staticClass: "history_detail_box" }, [
          _c("table", { staticClass: "list" }, [
            _vm._m(0),
            _c(
              "tbody",
              _vm._l(_vm.historyData.data.list, function (item, index) {
                return _c(
                  "tr",
                  {
                    key: index,
                    on: {
                      click: function ($event) {
                        return _vm.goToBattleDetail(item)
                      },
                    },
                  },
                  [
                    _c("td", [_vm._v(_vm._s(item.id))]),
                    _c("td", [
                      _c(
                        "div",
                        { staticClass: "user-images" },
                        [
                          _vm._l(item.players, function (player, index) {
                            return [
                              player.avatar
                                ? _c("img", {
                                    key: index,
                                    attrs: {
                                      src: _vm._f("imgfilter")(player.avatar),
                                    },
                                  })
                                : _c("img", {
                                    key: index,
                                    attrs: {
                                      src: require("@/assets/images/user/ava_none.jpg"),
                                    },
                                  }),
                            ]
                          }),
                        ],
                        2
                      ),
                    ]),
                    _c("td", [
                      _c(
                        "div",
                        { staticClass: "box-images" },
                        _vm._l(item.cases, function (box, index) {
                          return _c("img", {
                            key: index,
                            attrs: { src: _vm._f("imgfilter")(box.casePic) },
                          })
                        }),
                        0
                      ),
                    ]),
                    _c("td", [
                      _c("span", { staticClass: "price-text" }, [
                        _vm._v(_vm._s(item.roomPrice) + " $"),
                      ]),
                    ]),
                    _c("td", [_vm._v(_vm._s(item.statusTemp))]),
                    _c("td", [
                      _c("span", { staticClass: "time" }, [
                        _vm._v(_vm._s(item.createTime)),
                      ]),
                    ]),
                  ]
                )
              }),
              0
            ),
          ]),
          !_vm.historyData.data.list.length
            ? _c("div", { staticClass: "none-item" }, [
                _c("div", [_vm._v("暂无数据")]),
                _c("img", {
                  attrs: {
                    src: require("@/assets/images/none-item.svg"),
                    alt: "",
                  },
                }),
              ])
            : _vm._e(),
        ]),
        _c("Page", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.historyData.data.total > _vm.historyData.size,
              expression: "historyData.data.total > historyData.size",
            },
          ],
          attrs: {
            current: _vm.historyData.current,
            total: _vm.historyData.data.total,
            "page-size": _vm.historyData.size,
            "class-name": "page",
          },
          on: {
            "update:current": function ($event) {
              return _vm.$set(_vm.historyData, "current", $event)
            },
            "on-change": _vm.pageF,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("房间号")]),
        _c("th", [_vm._v("玩家")]),
        _c("th", [_vm._v("盲盒")]),
        _c("th", [_vm._v("价格")]),
        _c("th", [_vm._v("状态")]),
        _c("th", [_vm._v("时间")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }